module.exports = __webpack_public_path__ + "static/media/logo.eb45effd.png";